export default "__VITE_ASSET__DUK_K4Dj__"